// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as components from "../../js/components";
import * as constants from "../../js/constants";

import * as utils from "../../js/utils";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const RationalSelfListPage = () => {
  // TODO react hooks variables ////////////////////////////////////////////////////////////////////////////////////////
  const dispatch = useDispatch();
  // TODO custom variables /////////////////////////////////////////////////////////////////////////////////////////////
  const [firstRefresh, firstRefreshSet] = useState(true);
  const [author, authorSet] = useState("self");
  const [sort, sortSet] = useState("дате публикации (свежие в начале)");
  const [moderate, moderateSet] = useState("на доработку");
  // TODO react store variables ////////////////////////////////////////////////////////////////////////////////////////
  const UserListStore = useSelector((state) => state.UserListStore);
  const {
    data: dataUserList,
  } = UserListStore;
  //////////////////////////////////////////////////////////
  const rationalListStore = useSelector((state) => state.rationalListStore);
  const {
    load: loadRationalList,
    data: dataRationalList,
  } = rationalListStore;
  // TODO reset state //////////////////////////////////////////////////////////////////////////////////////////////////
  const resetState = async (e) => {
    try {
      e.preventDefault();
    } catch (error) {}
    dispatch({ type: constants.RATIONAL_LIST.reset });
  };
  //////////////////////////////////////////////////////////
  useEffect(() => {
    if (!dataRationalList) {
      const form = {
        "Action-type": "RATIONAL_LIST",
        moderate: moderate,
        sort: sort,
        author: author,
      };
      dispatch(
        utils.ActionConstructorUtility(
          form,
          "/api/auth/rational/",
          "POST",
          30000,
          constants.RATIONAL_LIST
        )
      );
    } else {
      if (firstRefresh) {
        firstRefreshSet(false);
        resetState();
      }
    }
  }, [dataRationalList, dataUserList, firstRefresh]);
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-0">
      <components.HeaderComponent />
      <main>
        <components.StoreStatusComponent
          storeStatus={rationalListStore}
          keyStatus={"rationalListStore"}
          consoleLog={constants.DEBUG_CONSTANT}
          showLoad={true}
          loadText={""}
          showData={false}
          dataText={""}
          showError={true}
          errorText={""}
          showFail={true}
          failText={""}
        />
        {!loadRationalList &&
          (!dataRationalList || dataRationalList.length < 1 ? (
            <div className="my-1">
              <components.MessageComponent variant={"danger"}>
                Ничего не найдено! Попробуйте изменить условия фильтрации и/или
                очистить строку поиска.
              </components.MessageComponent>
            </div>
          ) : (
            <ul className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 justify-content-center shadow text-center m-0 p-0 my-1">
              {dataRationalList.map((rational, index) => (
                <div
                  key={index}
                  className="col-sm-12 col-md-12 col-lg-6 m-0 p-1"
                >
                  <div className="m-0 p-0">
                    <div className="card shadow custom-background-transparent-low m-0 p-0">
                      <div className="card-header bg-warning bg-opacity-10 m-0 p-3">
                        <Link
                          to={`/rational_change/${rational["id"]}`}
                          className="text-decoration-none text-dark m-0 p-0"
                        >
                          <h6 className="lead fw-bold m-0 p-0">
                            {utils.GetSliceString(
                              rational["name_char_field"],
                              30
                            )}
                          </h6>
                          <h6 className="text-danger lead small m-0 p-0">
                            {" [ "}
                            {utils.GetSliceString(
                              rational["status_moderate_char_field"],
                              30
                            )}
                            {" : "}
                            {utils.GetSliceString(
                              rational["comment_moderate_char_field"],
                              30
                            )}
                            {" ]"}
                          </h6>
                        </Link>
                      </div>
                      <div className="card-body m-0 p-0">
                        <div className="m-0 p-0">
                          <label className="form-control-sm text-center m-0 p-1">
                            Подразделение:
                            <select
                              className="form-control form-control-sm text-center m-0 p-1"
                              required
                            >
                              <option className="m-0 p-0" value="">
                                {rational["subdivision_char_field"]}
                              </option>
                            </select>
                          </label>
                          <label className="form-control-sm text-center m-0 p-1">
                            Зарегистрировано за №
                            <strong className="btn btn-light disabled">
                              {`${rational["number_char_field"]}`}
                            </strong>
                          </label>
                        </div>
                        <div className="m-0 p-0">
                          <label className="form-control-sm text-center m-0 p-1">
                            Категория:
                            <select
                              className="form-control form-control-sm text-center m-0 p-1"
                              required
                            >
                              <option className="m-0 p-0" value="">
                                {rational["category_char_field"]}
                              </option>
                            </select>
                          </label>
                        </div>
                        <div className="m-0 p-0">
                          <img
                            src={
                              rational["image_field"]
                                ? utils.GetStaticFile(rational["image_field"])
                                : utils.GetStaticFile(
                                    "/media/default/idea/default_idea.jpg"
                                  )
                            }
                            className="img-fluid img-thumbnail w-50 m-1 p-0"
                            alt="изображение отсутствует"
                          />
                        </div>
                        <div className="m-0 p-0">
                          <label className="form-control-sm text-center w-50 m-0 p-1">
                            Место внедрения:
                            <input
                              type="text"
                              className="form-control form-control-sm text-center m-0 p-1"
                              defaultValue={utils.GetSliceString(
                                rational["place_char_field"],
                                50
                              )}
                              readOnly={true}
                              placeholder="введите место изменения тут..."
                              required
                              minLength="1"
                              maxLength="300"
                            />
                          </label>
                        </div>
                        <div className="m-0 p-0">
                          <label className="form-control-sm text-center w-100 m-0 p-1">
                          Проблема:
                            <textarea
                              className="form-control form-control-sm text-center m-0 p-1"
                              defaultValue={utils.GetSliceString(
                                rational["problem_text_field"],
                                100
                              )}
                              readOnly={true}
                              required
                              placeholder="введите проблему тут..."
                              minLength="1"
                              maxLength="3000"
                              rows="3"
                            />
                          </label>
                        </div>
                        <div className="m-0 p-0">
                          <label className="form-control-sm text-center w-100 m-0 p-1">
                            Решение:
                            <textarea
                              className="form-control form-control-sm text-center m-0 p-1"
                              defaultValue={utils.GetSliceString(
                                rational["solution_text_field"],
                                100
                              )}
                              readOnly={true}
                              required
                              placeholder="введите решение тут..."
                              minLength="1"
                              maxLength="3000"
                              rows="3"
                            />
                          </label>
                        </div>
                        <div className="m-0 p-0">
                          <label className="form-control-sm text-center w-100 m-0 p-1">
                            Эффект:
                            <textarea
                              className="form-control form-control-sm text-center m-0 p-1"
                              defaultValue={utils.GetSliceString(
                                rational["effect_text_field"],
                                100
                              )}
                              readOnly={true}
                              required
                              placeholder="введите эффект тут..."
                              minLength="1"
                              maxLength="3000"
                              rows="3"
                            />
                          </label>
                        </div>
                        <div className="m-0 p-0">
                          {rational["additional_word_file_field"] && (
                            <label className="form-control-sm text-center m-0 p-1">
                              Word файл-приложение:
                              <a
                                className="btn btn-sm btn-primary m-0 p-1"
                                href={utils.GetStaticFile(
                                  `${rational["additional_word_file_field"]}`
                                )}
                              >
                                Скачать документ
                              </a>
                            </label>
                          )}
                          {rational["additional_pdf_file_field"] && (
                            <label className="form-control-sm text-center m-0 p-1">
                              Pdf файл-приложение:
                              <a
                                className="btn btn-sm btn-danger m-0 p-1"
                                href={utils.GetStaticFile(
                                  `${rational["additional_pdf_file_field"]}`
                                )}
                              >
                                Скачать документ
                              </a>
                            </label>
                          )}
                          {rational["additional_excel_file_field"] && (
                            <label className="form-control-sm text-center m-0 p-1">
                              Excel файл-приложение:
                              <a
                                className="btn btn-sm btn-success m-0 p-1"
                                href={utils.GetStaticFile(
                                  `${rational["additional_excel_file_field"]}`
                                )}
                              >
                                Скачать документ
                              </a>
                            </label>
                          )}
                        </div>
                        <div className="m-0 p-0">
                          <Link
                            to={`#`}
                            className="btn btn-sm btn-warning m-0 p-2"
                          >
                            Автор:{" "}
                            {rational["user_model"]["last_name_char_field"]}{" "}
                            {rational["user_model"]["first_name_char_field"]}{" "}
                            {rational["user_model"]["position_char_field"]}
                          </Link>
                        </div>
                        <div className="d-flex justify-content-between m-1 p-0">
                          <label className="text-muted border m-0 p-2">
                            подано:{" "}
                            <p className="m-0">
                              {utils.GetCleanDateTime(
                                rational["created_datetime_field"],
                                true
                              )}
                            </p>
                          </label>
                          <label className="text-muted border m-1 p-2">
                            зарегистрировано:{" "}
                            <p className="m-0 p-0">
                              {utils.GetCleanDateTime(
                                rational["register_datetime_field"],
                                true
                              )}
                            </p>
                          </label>
                        </div>
                      </div>
                      <div className="card-footer m-0 p-1">
                        <div className="d-flex justify-content-between m-0 p-1">
                          <span
                            className={
                              rational["ratings"]["rate"] > 7
                                ? "text-success m-0 p-1"
                                : rational["ratings"]["rate"] > 4
                                ? "custom-color-warning-1 m-0 p-1"
                                : "text-danger m-0 p-1"
                            }
                          >
                            Рейтинг
                          </span>
                          <div className="m-0 p-1">
                            <span
                              className={
                                rational["ratings"]["rate"] > 7
                                  ? "btn btn-sm bg-success bg-opacity-50 badge rounded-pill m-0 p-2"
                                  : rational["ratings"]["rate"] > 4
                                  ? "btn btn-sm bg-warning bg-opacity-50 badge rounded-pill m-0 p-2"
                                  : "btn btn-sm bg-danger bg-opacity-50 badge rounded-pill m-0 p-2"
                              }
                            >
                              {`${rational["ratings"]["rate"]}  / ${rational["ratings"]["count"]}`}
                            </span>
                          </div>
                          <span className="m-0 p-1">
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 1
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 0.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 2
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 1.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 3
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 2.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 4
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 3.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 5
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 4.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 6
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 5.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 7
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 6.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 8
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 7.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 9
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 8.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                            <i
                              style={{
                                color:
                                rational["ratings"]["rate"] > 7
                                    ? "#00ff00"
                                    : rational["ratings"]["rate"] > 4
                                    ? "#ffaa00"
                                    : "#ff0000",
                              }}
                              className={
                                rational["ratings"]["rate"] >= 10
                                  ? "fas fa-star m-0 p-0"
                                  : rational["ratings"]["rate"] >= 9.5
                                  ? "fas fa-star-half-alt m-0 p-0"
                                  : "far fa-star m-0 p-0"
                              }
                            />
                          </span>
                        </div>
                        <div className="d-flex justify-content-between m-0 p-1">
                          <span className="text-secondary m-0 p-1">
                            Комментарии
                          </span>
                          <i className="fa-solid fa-comment m-0 p-1">
                            {" "}
                            {rational["comments"]["count"]}
                          </i>
                        </div>
                      </div>
                      <div className="m-0 p-0">
                        <Link
                          to={`/rational_change/${rational["id"]}`}
                          className="btn btn-sm btn-primary w-100 m-0 p-1"
                        >
                          редактировать
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </ul>
          ))}
      </main>
      <components.FooterComponent />
    </div>
  );
};
